import React from 'react';
import { Query } from '@cubejs-client/core';

import useCubeReportQuery from 'Hooks/query-hooks/reports/useCubeReportQuery';
import { generateChartData } from '../helpers';
import AcceptRejectChartDashlet from '../AcceptRejectChartDashlet';
import styles from './TransactionVolumeDashlet.css';

type Props = {
    formValues?: ProcessedNewMerchantReportFormValues;
    focusView: string;
};

const TransactionVolumeDashlet = ({ formValues, focusView }: Props) => {
    const { resultSet, isLoading } = useCubeReportQuery(
        formValues,
        formValues?.fullQueries?.transactionVolumeQuery as Query
    );

    const pivotData = resultSet?.chartPivot()[0];
    const { newSeriesData, percentageValue } = generateChartData(pivotData, focusView, 'volume');

    return (
        <AcceptRejectChartDashlet
            focusView={focusView}
            className={styles.container}
            seriesData={newSeriesData}
            isLoading={isLoading}
            header='Transaction Volume'
            totalLabel='Total Transactions'
            percentageValue={percentageValue}
            singleMerchantId={formValues?.singleMerchantId}
            dataTestId='transaction-volume-chart'
        />
    );
};

export default TransactionVolumeDashlet;
